<template>
  <li class="search-results__item author-result flex add-large-top-padding">
    <div class="author-image add-bottom-margin">
      <div>
        <a :href="getAuthorHref(result)">
          <img
            :src="result.PictureUrl ? result.PictureUrl : assignedAuthorImage"
            :alt="`${result.FirstName} ${result.LastName}`"
          />
        </a>
      </div>
    </div>
    <div class="col-7 author-text">
      <a class="type-link no-underline" :href="getAuthorHref(result)">
        <h3 class="type-h3 type-circular add-small-bottom-margin">
          {{ result.LastName }}, {{ result.FirstName }}
        </h3>
      </a>
      <p
        class="type-regular"
        v-if="result.Profile"
        v-html="shortenAuthorBio(result.Profile)"
      ></p>
      <p class="type-x-small" v-if="result.Titles.length > 0">
        More from this author:
        <span v-for="title in result.Titles.slice(0, 2)">
          <a class="type-link" :href="href(title)">{{ title.Name }}</a
          >&nbsp;
        </span>
      </p>
      <a
        v-if="result.Profile !== null"
        class="type-link type-small type-link--arrow"
        :href="getAuthorHref(result)"
      >
        View full profile
      </a>
    </div>
  </li>
</template>

<script>
export default {
  name: "GlobalSearchAuthorResults",
  props: ["result"],
  data() {
    return {
      assignedAuthorImage: "",
      authorImages: [
        "/images/DefaultAuthor1.jpg",
        "/images/DefaultAuthor2.jpg",
        "/images/DefaultAuthor3.jpg",
      ],
    };
  },
  created() {
    const index = Math.floor(Math.random() * this.authorImages.length);
    this.assignedAuthorImage = this.authorImages[index];
  },
  methods: {
    shortenAuthorBio(text) {
      const markup = text;
      const parser = new DOMParser().parseFromString(markup, "text/html");
      return `${parser.body.innerHTML
        .split(" ")
        .splice(0, 62)
        .join(" ")} ...`;
    },

    href(product, retail = false) {
      let path = "p";
      if (retail) {
        path = "s";
      }
      return `/${path}/${product.Id}/${product.SeName}`;
    },

    getAuthorHref(author) {
      return `/a/${author.Id}/${author.SeName}`;
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/GlobalSearchAuthorResults.vue